export interface AvailableLicenseForSelect {
  name: string;
  hint: string;
  description?: string;
  class?: string;
  button?: string;
  disabled?: boolean;
  id?: string | number;
}

export interface AvailableLicense {
  label: string;
  value: string | number;
  licenseId?: string;
}

export interface AvailableLicensesSelectElements {
  [ChangeLicenseCase.PAID]: false | AvailableLicense;
  [ChangeLicenseCase.BUY]: false | AvailableLicense;
  [ChangeLicenseCase.TRIAL]: false | AvailableLicense;
  [ChangeLicenseCase.POOL]: false | AvailableLicense;
}

export enum ChangeLicenseCase {
  PAID,
  BUY,
  TRIAL,
  POOL
}
